module.exports = __webpack_public_path__ + "img/logoWhite.015b0469.png";